import { defineEntity, custom } from './_helpers.js';

export default defineEntity('assetDisposal', {
    plannedReminder: custom({ scope: 'state' }),
});
